export const isShowTooltip = (tooltip: any) => {
	return tooltip.scrollWidth <= tooltip.clientWidth;
};
